import { render, staticRenderFns } from "./SendMessagePopup.vue?vue&type=template&id=7963ed39&scoped=true&"
import script from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
export * from "./SendMessagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendMessagePopup.vue?vue&type=style&index=0&id=7963ed39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963ed39",
  null
  
)

export default component.exports